var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vertical-flex-fit tab-container",
      on: { scroll: _vm.onScrollBottom },
    },
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center vertical-center h-100",
            },
            [
              _c("div", {
                staticClass: "spinner-border text-primary mb-5",
                staticStyle: { height: "5rem", width: "5rem" },
                attrs: { role: "status" },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "list-group list-group-flush" },
        [
          _vm._l(_vm.sortedReleaseNotes, function (ref) {
            var id = ref.id
            var description = ref.description
            var title = ref.title
            var version = ref.version
            var read = ref.read
            return _c(
              "li",
              {
                key: "release-note-" + id,
                staticClass: "list-group-item activity-item",
                class: { unread: !read },
              },
              [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col-12 mb-2" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "badge badge-primary release-version ml-0 mr-2 align-bottom",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-tags mr-1",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(
                          "\n            " + _vm._s(version) + "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "h5",
                      { staticClass: "text-gray release-version d-inline" },
                      [
                        _vm._v(
                          "\n            " + _vm._s(title) + "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("p", {
                      staticClass: "release-description",
                      domProps: { innerHTML: _vm._s(description) },
                    }),
                  ]),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _vm.loadingNotes ? _c("release-note-loader") : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }